module.exports = __webpack_public_path__ + "img/blue_103.d0dcfe5a.png";